import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';

export function initializeCalendar() {
  const calendarEl = document.getElementById('calendar')

  if (typeof calendarEl !== 'undefined' && calendarEl !== null) {
    let calendar = new Calendar(calendarEl, {
      themeSystem: 'bootstrap5',
      plugins: [dayGridPlugin, timeGridPlugin, listPlugin],
      initialView: 'dayGridMonth',
      eventSources: [{
        url: '/webapi/eventsapi/allevents',
        method: 'GET',
        failure: function () {
          console.log('there was an error while fetching events!')
        }
      }],
      eventClick: function (info) {
        console.log(info.event)
        $('#calendarModal').modal('show')
        $('#modalTitle').html(info.event.title)
        $('#modalBody').html(info.event.extendedProps.description)
      }
    })
    calendar.render()
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  initializeCalendar()
})
